import type {
  DomainRouterConnection,
  DomainRouterJsonInput,
} from '@triedge/domain-core';
import type {
  MessageThread,
  PortalMessage,
} from './index';

export type PortalThreadDetail = {
  thread: MessageThread;
  messages: PortalMessage[];
};

export type PortalMessageResult = {
  thread: MessageThread;
  message: PortalMessage;
};

export type PortalThreadListResponse = DomainRouterConnection<MessageThread>;

export const MESSAGING_QUERY_OPERATION_IDS = [
  'listMessageThreads',
  'getMessageThread',
] as const;

export const MESSAGING_MUTATION_OPERATION_IDS = [
  'sendMessage',
  'markMessageRead',
] as const;

export type MessagingQueryOperationId = (typeof MESSAGING_QUERY_OPERATION_IDS)[number];
export type MessagingMutationOperationId = (typeof MESSAGING_MUTATION_OPERATION_IDS)[number];

export type MessagingQueryArgsMap = {
  listMessageThreads: { input?: DomainRouterJsonInput };
  getMessageThread: { threadId: string };
};

export type MessagingQueryResultMap = {
  listMessageThreads: PortalThreadListResponse;
  getMessageThread: PortalThreadDetail;
};

export type MessagingMutationArgsMap = {
  sendMessage: { input: DomainRouterJsonInput };
  markMessageRead: { input: DomainRouterJsonInput };
};

export type MessagingMutationResultMap = {
  sendMessage: PortalMessageResult;
  markMessageRead: PortalMessage;
};
